export default __webpack_public_path__ + "static/media/logo.f5d2dc9c.svg";